



























































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class SelectFieldSearch extends Vue {
  private word: string = this.$store.state.machineRentState.fieldSearchText

  @Prop() private count!: number

  @Watch('$store.state.machineRentState.fieldSearchText')
  private onDataChange (word: string) {
    this.word = word
  }

  private doMasterFieldSearch () {
    this.$store.commit('machineRentState/setFieldSearchText', this.word)
    this.$emit('search-list')
  }

  private doClear () {
    this.word = ''

    /* stateリセット */
    this.$store.commit('machineRentState/setFieldSearchText', this.word)
    this.$emit('reset-list')
  }
}
